import { render, staticRenderFns } from "./FAQ.List.vue?vue&type=template&id=9c74e63e&"
import script from "./FAQ.List.vue?vue&type=script&lang=js&"
export * from "./FAQ.List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports